import { createContext, useContext, useEffect, useState, type ReactNode } from "react";
import { api, type Stats } from "./api";
import { emptyObservation, observe, type Observation } from "./observation";

export function useObservation<T>(read: (signal: AbortSignal) => Promise<T>): Observation<T> {
  const [observed, setObserved] = useState<{ read: typeof read; state: Observation<T> } | null>(null);
  useEffect(() => observe(read, (state) => setObserved({ read, state })), [read]);
  // Effects run after render: never show another filter's observations meanwhile.
  return observed?.read === read ? observed.state : emptyObservation<T>();
}

const StatsContext = createContext<Observation<Stats>>(emptyObservation());
export function StatsProvider({ children }: { children: ReactNode }) {
  const state = useObservation(api.stats);
  return <StatsContext.Provider value={state}>{children}</StatsContext.Provider>;
}
export const useStats = () => useContext(StatsContext);
